module.exports = __webpack_public_path__ + "img/icon-notification-light-blue-off.3a435cfb.svg";